/**
 * Constantes para a Central de Atendimento
 */

// Status de atendimento
export const SERVICE_STATUS = {
  NEW: "new",
  IN_SERVICE: "in_service",
  WAITING: "waiting",
  FINISHED: "finished",
};

export const SERVICE_STATUS_CONFIG = {
  [SERVICE_STATUS.NEW]: {
    label: "Novo",
    color: "#ef4444",
    bgColor: "#fef2f2",
    icon: "🔴",
  },
  [SERVICE_STATUS.IN_SERVICE]: {
    label: "Em Atendimento",
    color: "#06b776",
    bgColor: "#ecfdf5",
    icon: "🟢",
  },
  [SERVICE_STATUS.WAITING]: {
    label: "Aguardando",
    color: "#f59e0b",
    bgColor: "#fffbeb",
    icon: "🟡",
  },
  [SERVICE_STATUS.FINISHED]: {
    label: "Finalizado",
    color: "#64748b",
    bgColor: "#f1f5f9",
    icon: "⚫",
  },
};

// Status da sessão de atendimento
export const SESSION_STATUS = {
  ACTIVE: "active",
  TRANSFERRED: "transferred",
  FINISHED: "finished",
  ABANDONED: "abandoned",
};

export const SESSION_STATUS_CONFIG = {
  [SESSION_STATUS.ACTIVE]: {
    label: "Ativa",
    color: "#06b776",
    icon: "🟢",
  },
  [SESSION_STATUS.TRANSFERRED]: {
    label: "Transferida",
    color: "#6f42c1",
    icon: "🔄",
  },
  [SESSION_STATUS.FINISHED]: {
    label: "Finalizada",
    color: "#64748b",
    icon: "✅",
  },
  [SESSION_STATUS.ABANDONED]: {
    label: "Abandonada",
    color: "#ef4444",
    icon: "❌",
  },
};

// Tipos de nota
export const NOTE_TYPES = {
  GENERAL: "general",
  IMPORTANT: "important",
  WARNING: "warning",
  FOLLOW_UP: "follow_up",
  TRANSFER: "transfer",
};

export const NOTE_TYPE_CONFIG = {
  [NOTE_TYPES.GENERAL]: {
    label: "Geral",
    color: "#64748b",
    bgColor: "#f1f5f9",
    icon: "📝",
  },
  [NOTE_TYPES.IMPORTANT]: {
    label: "Importante",
    color: "#92400e",
    bgColor: "#fffbeb",
    icon: "⭐",
  },
  [NOTE_TYPES.WARNING]: {
    label: "Alerta",
    color: "#991b1b",
    bgColor: "#fef2f2",
    icon: "⚠️",
  },
  [NOTE_TYPES.FOLLOW_UP]: {
    label: "Acompanhamento",
    color: "#155e75",
    bgColor: "#ecfeff",
    icon: "📅",
  },
  [NOTE_TYPES.TRANSFER]: {
    label: "Transferência",
    color: "#6f42c1",
    bgColor: "#e8daef",
    icon: "🔄",
  },
};

// Status do bot
export const BOT_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
};

export const BOT_STATUS_CONFIG = {
  [BOT_STATUS.INACTIVE]: {
    label: "Desativado",
    color: "#ef4444",
    icon: "🔴",
  },
  [BOT_STATUS.ACTIVE]: {
    label: "Ativo",
    color: "#06b776",
    icon: "🟢",
  },
};

// Filtros da lista de conversas
export const CONVERSATION_FILTERS = {
  STATUS: {
    ALL: "all",
    NEW: "new",
    IN_SERVICE: "in_service",
    WAITING: "waiting",
    FINISHED: "finished",
  },
  ATTENDANT: {
    ALL: "all",
    MINE: "mine",
  },
};

// Configurações de paginação
export const PAGINATION = {
  CONVERSATIONS_PER_PAGE: 20,
  MESSAGES_PER_PAGE: 30,
  NOTES_PER_PAGE: 20,
  SESSIONS_PER_PAGE: 10,
};

// Atalhos de teclado
export const KEYBOARD_SHORTCUTS = {
  SEND_MESSAGE: "Ctrl+Enter",
  OPEN_TRANSFER: "Ctrl+T",
  FINISH_SERVICE: "Ctrl+F",
  NEW_NOTE: "Ctrl+N",
  SEARCH: "Ctrl+K",
  CLOSE: "Escape",
};

// Tipos de mídia suportados
export const MEDIA_TYPES = {
  IMAGE: "image",
  AUDIO: "audio",
  VIDEO: "video",
  DOCUMENT: "document",
  PTT: "ptt", // Push to Talk (áudio de voz)
  STICKER: "sticker",
};

// Action Types para o Reducer
export const ACTION_TYPES = {
  // Contas
  SET_ACCOUNTS: "SET_ACCOUNTS",
  SET_SELECTED_ACCOUNT: "SET_SELECTED_ACCOUNT",

  // Conversas
  SET_CONVERSATIONS: "SET_CONVERSATIONS",
  ADD_CONVERSATIONS: "ADD_CONVERSATIONS",
  UPDATE_CONVERSATION: "UPDATE_CONVERSATION",
  SET_SELECTED_CONVERSATION: "SET_SELECTED_CONVERSATION",

  // Contato
  SET_SELECTED_CONTACT: "SET_SELECTED_CONTACT",
  UPDATE_CONTACT: "UPDATE_CONTACT",

  // Mensagens
  SET_MESSAGES: "SET_MESSAGES",
  ADD_MESSAGES: "ADD_MESSAGES",
  ADD_MESSAGE: "ADD_MESSAGE",
  UPDATE_MESSAGE: "UPDATE_MESSAGE",

  // Notas
  SET_NOTES: "SET_NOTES",
  ADD_NOTE: "ADD_NOTE",
  UPDATE_NOTE: "UPDATE_NOTE",
  DELETE_NOTE: "DELETE_NOTE",

  // Sessões
  SET_SESSIONS: "SET_SESSIONS",
  SET_CURRENT_SESSION: "SET_CURRENT_SESSION",

  // Filtros
  SET_FILTERS: "SET_FILTERS",
  RESET_FILTERS: "RESET_FILTERS",
  SET_SELECTED_CHANNELS: "SET_SELECTED_CHANNELS",

  // UI State
  SET_LOADING: "SET_LOADING",
  TOGGLE_CONTACT_PANEL: "TOGGLE_CONTACT_PANEL",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  SET_MOBILE: "SET_MOBILE",

  // Unread counts
  SET_UNREAD_COUNT: "SET_UNREAD_COUNT",
  RESET_UNREAD_COUNT: "RESET_UNREAD_COUNT",

  // Reset
  RESET_STATE: "RESET_STATE",
};
